import React from 'react';
import { Checkbox } from 'primereact/checkbox';
import styles from './Checkbutton.module.scss';

export default function Checkbutton({
    name,
    formik,
    value,
    label,
    completeObject = {},
    rowReverse = true,
    afterChange,
    className,
    hasBollean = false,
    optionId = 'id',
    ...rest
}) {
    const isCheck = () => {
        if (hasBollean) {
            return formik.values?.[name] === true;
        }

        if (Array.isArray(formik.values?.[name]))
            return formik.values?.[name].filter((el) => el?.[optionId] === value).length > 0;
        else return false;
    };
    return (
        <div
            className={`${rowReverse ? styles.containerReverse : styles.container} ${
                className ?? ''
            }`}
        >
            <div className={styles.label}>{label}</div>
            <div className={styles.radioContainer}>
                <Checkbox
                    name={hasBollean ? name : formik.values?.[name]}
                    onChange={(ev) => {
                        if (hasBollean) {
                            return formik.setFieldValue(name, !(formik.values?.[name] === true));
                        }

                        let res = formik.values?.[name] ?? [];

                        if (ev.checked) {
                            if (res.filter((el) => el?.[optionId] === ev.value).length <= 0)
                                res = [...res, { [optionId]: ev.value, ...completeObject }];
                        } else {
                            res = res.filter((el) => el?.[optionId] !== ev.value);
                        }

                        if (afterChange) {
                            afterChange({ name, lastValue: formik.values?.[name], newValue: res });
                        }
                        formik.setFieldValue(name, res);
                    }}
                    value={value}
                    checked={isCheck()}
                    {...rest}
                />
            </div>
        </div>
    );
}
